import { render, staticRenderFns } from "./SellHeader.vue?vue&type=template&id=0cf5d551&scoped=true&"
import script from "./SellHeader.vue?vue&type=script&lang=js&"
export * from "./SellHeader.vue?vue&type=script&lang=js&"
import style0 from "./SellHeader.vue?vue&type=style&index=0&id=0cf5d551&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf5d551",
  null
  
)

export default component.exports